import React, { useState, useEffect, useRef } from 'react';
import '../styles/slider.scss';

export const Slider = ({ slides, onSlideChange, autoPlayInterval = 5000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
    const timerRef = useRef(null);

    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientY);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientY);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;

        const distance = touchStart - touchEnd;
        const isSwipeUp = distance > 50;
        const isSwipeDown = distance < -50;

        if (isSwipeUp) {
            nextSlide();
        }

        if (isSwipeDown) {
            prevSlide();
        }

        setTouchStart(0);
        setTouchEnd(0);
    };

    useEffect(() => {
        if (slides?.length) {
            timerRef.current = setInterval(() => {
                nextSlide();
            }, autoPlayInterval);
        }


        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, [currentIndex, autoPlayInterval, slides]);


    const nextSlide = () => {
        const newIndex = (currentIndex + 1) % slides.length;
        setCurrentIndex(newIndex);
        if (typeof (onSlideChange) === 'function')
            onSlideChange(slides[newIndex]);
    };

    const prevSlide = () => {
        const newIndex = (currentIndex - 1 + slides.length) % slides.length;
        setCurrentIndex(newIndex);
        if (typeof (onSlideChange) === 'function')
            onSlideChange(slides[newIndex]);
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
        if (typeof (onSlideChange) === 'function')
            onSlideChange(slides[index]);
    };


    if (!slides || slides.length === 0) return null;

    return (
        <div
            className="slider__container"
        >
            <div
                className="slider__viewport"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                <div
                    className="slider__track"
                    style={{ transform: `translateY(-${currentIndex * 100}%)` }}
                >
                    {slides.map((slide, index) => (
                        <div key={index} className="slider__slide">
                            <div className="slider__image-wrapper">
                                <img
                                    src={slide.image}
                                    alt={slide.title}
                                    className="slider__image"
                                />
                            </div>
                            <div className="slider__text">
                                <div dangerouslySetInnerHTML={{ __html: slide.text }} style={{ wordBreak: "break-word" }} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="slider__dots">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        className={`slider__dot ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                    />
                ))}
            </div>
        </div>
    );
};